import { IconProps } from '@/interface/interface';

import {
  HomeOutlined, DashboardOutlined, SearchOutlined, EditOutlined, DeleteOutlined, PhoneOutlined, ArrowLeftOutlined, EyeInvisibleOutlined, EyeOutlined, LoadingOutlined, LockOutlined, MailOutlined, UserOutlined, SettingOutlined, SafetyOutlined, PlusOutlined
} from '@ant-design/icons';
import { AiOutlineDownload } from "react-icons/ai";


import { MdOutlineDashboard } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import { IoShieldOutline, IoAccessibility } from "react-icons/io5";
import { LuChartPie, LuFileImage, LuChartColumn, LuTrendingUp } from "react-icons/lu";
import { FaUserCheck } from "react-icons/fa";

export const IconDashboardMd = (props: IconProps) => <MdOutlineDashboard {...props} />;
export const IconFiDownload = (props: IconProps) => <FiDownload {...props} />;
export const IconLuChartColumn = (props: IconProps) => <LuChartColumn {...props} />;
export const IconLuTrendingUp = (props: IconProps) => <LuTrendingUp {...props} />;
export const IconLuChartPie = (props: IconProps) => <LuChartPie {...props} />;
export const IconIoShieldOutline = (props: IconProps) => <IoShieldOutline {...props} />;
export const IconEyeInvisible = (props: IconProps) => <EyeInvisibleOutlined {...props} />;
export const IconEyeOutlined = (props: IconProps) => <EyeOutlined {...props} />;
export const IconLoadingOutlined = (props: IconProps) => <LoadingOutlined {...props} />;
export const IconLockOutlined = (props: IconProps) => <LockOutlined {...props} />;
export const IconMailOutlined = (props: IconProps) => <MailOutlined {...props} />;
export const IconUser = (props: IconProps) => <UserOutlined {...props} />;
export const IconSettings = (props: IconProps) => <SettingOutlined {...props} />;
export const IconPhone = (props: IconProps) => <PhoneOutlined {...props} />;
export const IconSafety = (props: IconProps) => <SafetyOutlined {...props} />;
export const IconPlusOutlined = (props: IconProps) => <PlusOutlined {...props} />;
export const IconSearchOutlined = (props: IconProps) => <SearchOutlined {...props} />;
export const IconEditOutlined = (props: IconProps) => <EditOutlined {...props} />;
export const IconHome = (props: IconProps) => <HomeOutlined {...props} />;
export const IconDeleteOutlined = (props: IconProps) => <DeleteOutlined {...props} />;
export const IconDashboard = (props: IconProps) => <DashboardOutlined {...props} />;
export const IconArrowLeft = (props: IconProps) => <ArrowLeftOutlined {...props} />;
export const IconUserCheck = (props: IconProps) => <FaUserCheck {...props} />;
export const IconIoAccessibility = (props: IconProps) => <IoAccessibility {...props} />;
export const IconAiOutlineDownload = (props: IconProps) => <AiOutlineDownload {...props} />;